import { useLocation } from "react-router";
import { getBreadcrumbRoute } from "@/utils/getBreadcrumbRoute";
import Breadcrumb from "../Breadcrumb";

const BreadcrumbsNav = () => {
  const location = useLocation();
  // Get breadcrumbs data
  const breadcrumbOptions = getBreadcrumbRoute(location);

  return <Breadcrumb options={breadcrumbOptions} />;
};

export default BreadcrumbsNav;
